import { DateTime } from 'luxon';
import { Plan, PricingScheme, SubscriptionApiResponse } from '../../api/BillingApi';
import { CurrencyCode } from '../../config/CurrencyCode';
import { BillingStatus } from './Group';
import { BillingFrequency } from '../../config/Constants';

export class Subscription {
  cancelUrl: string;
  currency: CurrencyCode;
  nextBillDate: DateTime;
  nextPaymentAmount: number;
  paddleSubscriptionId: number;
  pausedAt: DateTime;
  pausedFrom: DateTime;
  pausedReason: string;
  quantity: number;
  subscriptionPlanId: number;
  subscriptionStatus: BillingStatus;
  billingFrequency: BillingFrequency;
  updateUrl: string;
  plan: Plan;
  pricingStructure: PricingScheme;

  static fromApi(apiData: SubscriptionApiResponse): Subscription {
    const sub = new Subscription();

    sub.cancelUrl = apiData.cancelUrl;
    sub.currency = apiData.currency as CurrencyCode;
    sub.nextBillDate = DateTime.fromISO(apiData.nextBillDate);
    sub.nextPaymentAmount = apiData.nextPaymentAmount;
    sub.paddleSubscriptionId = apiData.paddleSubscriptionId;
    sub.pausedAt = DateTime.fromISO(apiData.pausedAt);
    sub.pausedFrom = DateTime.fromISO(apiData.pausedFrom);
    sub.pausedReason = apiData.pausedReason;
    sub.quantity = apiData.quantity;
    sub.subscriptionPlanId = apiData.subscriptionPlanId;
    sub.subscriptionStatus = apiData.subscriptionStatus as BillingStatus;
    sub.billingFrequency = apiData.billingFrequency as BillingFrequency;
    sub.updateUrl = apiData.updateUrl;
    sub.plan = apiData.plan as Plan;
    sub.pricingStructure = apiData.pricingStructure as PricingScheme;

    return sub;
  }
}
